module.exports = __webpack_public_path__ + "media/images/doc-pdf-ab0417c0954841a9cf7589aa392e061a.png";